import React from 'react';
import './floatingCubes.scss';

function FloatingCubes({ origin, reverse }) {
  return (
    <section
      className={
        reverse
          ? `floatingCubes floatingCubes--reverse floatingCubes--${origin} `
          : `floatingCubes floatingCubes--${origin}`
      }
    >
      <span className={`floatingCubes-s floatingCubes--${origin}-s`}></span>
      <span className={`floatingCubes-l floatingCubes--${origin}-l`}></span>
    </section>
  );
}

export default FloatingCubes;
